import { render } from "./EventAddModal.vue?vue&type=template&id=b6e61fca&scoped=true"
import script from "./EventAddModal.vue?vue&type=script&lang=js"
export * from "./EventAddModal.vue?vue&type=script&lang=js"

import "./EventAddModal.vue?vue&type=style&index=0&id=b6e61fca&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b6e61fca"],['__file',"src/containers/event/eventSettings/EventAddModal.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "b6e61fca"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('b6e61fca', __exports__)) {
    api.reload('b6e61fca', __exports__)
  }
  
  module.hot.accept("./EventAddModal.vue?vue&type=template&id=b6e61fca&scoped=true", () => {
    api.rerender('b6e61fca', render)
  })

}


export default __exports__